import { EventEmitterService } from '@core/services/event-emitter.service';
import { tap, map } from 'rxjs/operators';
import { Pagination } from '../../shared/models/pagination.model';
import { PortalMessage } from '@shared/models/portal-message.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiResponse } from '@shared/models/api-response.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { SocketIoService } from './socket.io-service';

@Injectable({
  providedIn: 'root'
})
export class PortalMessageHttpService {

    pagination: Pagination;
    messages$ = new Subject<any[]>();
    isSuccess: boolean;
    messageCount$ = new BehaviorSubject<number>(0);
    messageSubject = new Subject<any>();

    private messageChannelName: string;
    private unsubscribeMessage: (() => void) | null = null;

    constructor(
      private http: HttpClient, 
      private eventEmitterService: EventEmitterService, 
      private socketIoService: SocketIoService
    ) { }

    getWithQuery(pageParam: string): Observable<PortalMessage[]>{
      return this.http.get<ApiResponse>(`/message${pageParam}`).pipe(
        tap(res => this.paginationInit(res)),
        map(res => res.data.rows)
      );
    }

    getUnread(): Observable<any>{
      return this.http.get<ApiResponse>(`/message/unread`).pipe(
        tap(res => {
          if (res.data.rows.new_messages > 0){
            this.eventEmitterService.onReloadUreadMessage();
            this.messageCount$.next(res.data.rows.new_messages);
          }
        }),
        map(res => res.data.rows.new_messages)
      );
    }

    updateRead(data: any){
      return this.http.post<ApiResponse>(`/message/read`, data);
    }

    private paginationInit(res: any) {
      if (res) {
        this.pagination = res.data.paginations;
      }
    }

    deleteMessage(data: any) {
      return this.http.delete<ApiResponse>(`/message${data}`).pipe(
        tap((res: any) => {
          this.messages$.next(res.message);
          this.isSuccess = res.success;
        })
      );
    }

    getContents(id: number): Observable<PortalMessage> {
      return this.http.get<ApiResponse>(`/message/${id}`).pipe(
        map(res => res.data.rows)
      )
    }

    messageWebsocket(memberAccountId: number) {
      this.disconnectSocket();

      this.messageChannelName = 'message-channel.' + memberAccountId;
      this.unsubscribeMessage = this.socketIoService
        .channel(this.messageChannelName)
        .listen('MessageEvent', (data: any) => {
          this.messageCount$.next(data.unread);
          this.messageSubject.next(data);
          if (data && data.event_type == 'new') {
            this.messages$.next([data.title]);
          }
        });
    }

    disconnectSocket() {
      if (this.unsubscribeMessage) {
        this.unsubscribeMessage();
      }
      if (this.messageChannelName) {
        this.socketIoService.leave(this.messageChannelName);
      }
      this.unsubscribeMessage = null;
    }
}
